import { Country } from '@core/enums/country.enum';
import { Currency } from '@core/enums/currency.enum';
import { LogLevel } from '@core/enums/log-level.enum';

export const environment = {
  production: true,
  ecommerceBackendUri: 'https://api-online-dev.princesshouse.tech/',
  consultantCorner2Uri: 'https://dev-cc.princesshouse.com',
  startNowAppBackendUri: 'https://dev-cc-api.princesshouse.com/startnowapp/',
  ecommerceBackendClientId: 'storefrontApp',
  ecommerceBackendClientSecret: 'storefrontSecret',
  country: Country.Usa,
  currency: Currency.Usa,
  languages: [
    { code: 'en-US', lid: 0 },
    { code: 'es-US', lid: 1 },
  ],
  nexioPaymentApiUri: undefined,
  ec1StartYourBusinessUrl: 'https://www.princesshouse.com/start-now-app/',
  agreementHtmlBaseUrl: 'https://ststartnowdev.blob.core.windows.net',
  storeLocatorUrl: undefined,
  gtmContainerId: 'GTM-P3JS48N',
  logRocketId: 'pikrdj',
  appcuesId: '134956',
  cookieBotId: '85f086ca-3fb5-4772-9f4d-57afcb11d5cd',
  recaptchaSiteKey: '6LeuijwmAAAAAOn7NOi36nMtAA_2_0flzFLLuBXH',
  recaptchaSiteKeyV2: '6Le1rasrAAAAANflpxSPjWMrUCLh0Hr5ImPSnQKk',
  environmentName: 'ph-ec-dev-usa',
  highestConsolLogLevel: LogLevel.Error,
  b2c: {
    tenant: 'phecdevb2c',
    domain: 'dev-ec-login.princesshouse.tech',
    clientId: '0455f102-c312-4860-8fe8-fd68bba22dd1',
    customerScope:
      'https://phecdevb2c.onmicrosoft.com/9d033720-d302-4632-8516-2944aa655afd/customer',
  },
  feature: {
    product: true,
    consultantFinder: true,
    consultantCorner: true,
    footerSocial: true,
    footerExtra: true,
    contactUsLocation: true,
    productReview: true,
    isAccessibeEnabled: true,
    mobileLogin: true,
  },
  tel: {
    mask: '(000) 000 0000',
    prefix: '+1 ',
    customerService: {
      prefix: '1',
      number: '508-823-6800',
    },
    career: {
      prefix: '1',
      number: '800-622-0039',
    },
    homeOfficeMember: {
      prefix: '1',
      number: '508-823-0711',
    },
  },
  datadog: null,
};
